module.exports = __webpack_public_path__ + "static/media/control_de_carga2.a6db98ce.svg";